var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0638 46.6043H1.65736L14.866 37.2541H29.8757L21.0638 46.6043ZM74.9362 46.6043H94.3426L81.134 37.2541H66.1241L74.9362 46.6043ZM37.5662 97H46.0031V69.1343H37.5662V97ZM49.1218 97H57.5586V69.1343H49.1218V97ZM96 49.7333V97H60.6775V67.5698V66.0053H59.1181H49.1218H46.0031H36.0068H34.4475V67.5698V97H0V49.7333H22.4071L35.2036 36.1552L46.4406 24.2318V0H49.5594H66.6572L65.8539 0.524785L56.8286 6.42113L65.8539 12.3177L66.6572 12.8423H49.5594V24.2316L60.7964 36.155L73.5929 49.7332H96V49.7333ZM14.9332 81.4823H6.04445V90.4004H14.9332V81.4823ZM14.9332 67.5698H6.04445V76.4879H14.9332V67.5698ZM29.1555 81.4823H20.2667V90.4004H29.1555V81.4823ZM29.1555 67.5698H20.2667V76.4879H29.1555V67.5698ZM55.2888 50.8034C55.2888 46.7646 52.0255 43.4905 48 43.4905C43.9745 43.4905 40.7112 46.7646 40.7112 50.8034C40.7112 54.8421 43.9745 58.1165 48 58.1165C52.0255 58.1165 55.2888 54.8423 55.2888 50.8034ZM75.7333 81.4823H66.8445V90.4004H75.7333V81.4823ZM75.7333 67.5698H66.8445V76.4879H75.7333V67.5698ZM89.9556 81.4823H81.0668V90.4004H89.9556V81.4823ZM89.9556 67.5698H81.0668V76.4879H89.9556V67.5698Z",
    fill: "#AEA6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord21);
export default __webpack_public_path__ + "static/media/accord_21.59a06896784cfc513a1a389ed4778c46.svg";
export { ForwardRef as ReactComponent };